import React     from 'react';
import PropTypes from 'prop-types';

import * as S                from './info-bm.module.scss';
import { SubActionRow }      from '../sub-action-row';
import { Expiry }            from '../../../common/product/expiry';
import { Price }             from '../../../common/product/price';
import { ProductName }       from '../../../common/product/prod-name';
import { TagLine }           from '../../../common/product/tag-line';
import { useGlobalCtx }      from '../../../../context/ctx-hook';
import * as ProductSelectors from '../../../../context/selectors/product-selectors';
import { BmTopToggle }       from '../info-bm/bm-top-up';
import * as BillSelectors      from '../../../../context/selectors/bill-selectors';
import * as UserSelectors from '../../../../context/selectors/user-selectors';
import * as Actions from '../../../../context/ctx-actions';
import { MODALS } from '../../../../helpers/constants/state-constants';
import { Quota } from '../../../common/product/quota';
import { getProductLogo } from '../../../../context/selectors/product-selectors';


const InfoBm = ({product, isCancelAr, bmType, onClose}) => {
  const {globalDispatch, state} = useGlobalCtx();
  const BM_TYPE = bmType;
  const SUB = ProductSelectors.getSubscription(state, product);
  // const QKN_SUB = ProductSelectors.getSubscription(state, state.country == 'us' ? 'quicken-us' : 'quicken-ca');
  const QKN_SUB = BillSelectors.getQknSubscription(state, state?.country);
  const qknIsCfe = QKN_SUB?.tierUriName === 'family-enterprise';
  const qknIsActive = BillSelectors.getQknSubscriptionObj(QKN_SUB, state?.country)?.active;
  // const QKN_SUB_IS_BUNDLE = QKN_SUB?.txnId;
  // const QKN_PRODUCT_LINE = `quicken-${state?.country}`;
  // const qknIsActive = QKN_SUB_IS_BUNDLE ? QKN_SUB?.subscriptions.find(sub => sub?.productLineUriName == QKN_PRODUCT_LINE)?.active : QKN_SUB?.active;
  const RENEWAL_NAME = SUB?.renewalTierName;
  const SAME_PLAN    = (SUB?.renewalTierName === undefined) || (SUB?.renewalTierName === SUB?.tierName);
  const PRICE_SKU    = ProductSelectors.uriNameToSku(SAME_PLAN ? SUB?.tierUriName : SUB?.renewalTierUriName);

  // FREE BM STUFF
  const BM_MAX_ENT = BM_TYPE === 'FREE' ? BillSelectors.getMaxEntitlement(state) : [];
  const BM_ENT_DATA = BillSelectors.getBmTierData(BM_MAX_ENT);
  const IS_PROMO_ENT = BillSelectors.getBMHasPromoEntitlement(state);
  const BM_ENT = IS_PROMO_ENT ? ProductSelectors.getSubscription(state, 'billmanager-promotion') : false;
  const PRODUCT =  IS_PROMO_ENT ?
    'billmanager-promotion':
    'billmanager';

  // const PRODUCT_PAYMENT = UserSelectors.getProductsPaymentMethod(PRODUCT, state);

  // console.log('QKN_SUB:', QKN_SUB);
  console.log('BM_TYPE:', BM_TYPE);
  console.log('bmType:', bmType);
  // console.log('qknIsActive:', qknIsActive);

  const handleChangePlan = React.useCallback(
    () => globalDispatch(Actions.setCtxNestedObj('modal', {
      type:       MODALS.CHANGE_PLAN,
      ctx:        {product: PRODUCT},
      isLoading:  true,
      hasError:   false,
      isDisabled: false
    })),
    [globalDispatch]
  );
  // END BM FREE STUFF

  return (
    <article className={`${S.card} ${BM_TYPE === 'PAID' ? SUB.tierUriName : BM_ENT_DATA.tier}`}>
      <div className={S.productInfo}>
        <div className={S.leftSide}>
          <div className={S.productHeader}>
            {BM_TYPE === 'PAID' ?
              <img alt="square product logo" src={getProductLogo(SUB)} /> :
              <img alt="square product logo" src={getProductLogo({productLineUriName: 'quicken-us'})} />
            }

            <div className={S.headerText}>
              {BM_TYPE === 'PAID' &&
                <ProductName sub={SUB} product='bill manager' className={S.prodName}/>
              }

              {BM_TYPE != 'PAID' && BM_ENT &&
                <ProductName sub={BM_ENT} product='bill manager' className={S.qknName}/>
              }

              {BM_TYPE != 'PAID' && BM_ENT_DATA &&
                <ProductName sub={BM_ENT_DATA} product='bill manager' className={S.qknName} />
              }


              {BM_TYPE === 'PAID' ?
                <TagLine uriName={SUB?.tierUriName} className={S.tagLine}/> :
                <TagLine uriName={BM_ENT_DATA?.tier} className={S.tagLine}/>
              }

              {BM_TYPE === 'FREE' && !IS_PROMO_ENT &&
                <p className={S.benefit}>Included with Quicken {QKN_SUB.tierName}</p>
              }

              {BM_TYPE === 'PAID' ?
                <Quota sku={SUB?.sku}/> :
                <Quota quotaData={BM_ENT_DATA}/>
              }

              {!isCancelAr && !qknIsCfe &&
                <BmTopToggle
                  custClass="tileToggle"
                />
              }

              {BM_TYPE === 'PAID' && !isCancelAr && !qknIsCfe &&
                <SubActionRow product={product} onClose={onClose} isAddon={true} />
              }

              {BM_TYPE !== 'PAID' && qknIsActive && !isCancelAr &&
                <div>
                  <button
                    type="button"
                    onClick={handleChangePlan}
                    className={S.linkBtn}
                    data-testid="BTN_BM_BUY_MORE"
                  >
                    {IS_PROMO_ENT ?
                      'Buy More Payments' :
                      'Upgrade Plan'
                    }
                  </button>
                </div>
              }
            </div>
          </div>
        </div>

        {BM_TYPE === 'PAID' && (
          <div className={S.rightSide}>
            {BM_TYPE === 'PAID' && SUB?.autoRenew &&
            <div className={S.priceArea}>
              <Price
                sku={PRICE_SKU}
                renewalFrequency={SUB.renewalFrequency}
                className={S.priceRow}
              />
              {RENEWAL_NAME && (
                <div className={S.renewalName}>Renews at {`${SUB.productLineName} ${SUB.renewalTierName}` || SUB.tierName}</div>
              )}
            </div>
            }

            {BM_TYPE === 'PAID' &&
            <Expiry product={product} className={S.infoExpiryRow} />
            }
          </div>
        )}

      </div>
    </article>
  );
};

InfoBm.displayName = 'InfoBm';
InfoBm.propTypes   = {
  product: PropTypes.string.isRequired,
  isCancelAr: PropTypes.bool.isRequired,
  bmType: PropTypes.string,
  onClose: PropTypes.func.isRequired
};

export { InfoBm };
